import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 495.281 495.281"},
  viewBox: "0 0 495.281 495.281"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M264.082 433.09V263.641c79.75-9.133 136.491-75.908 136.491-152.08 0-28.795-7.996-64.61-21.854-99.33A19.437 19.437 0 0 0 360.671 0h-226.19a19.43 19.43 0 0 0-18.049 12.232C103.92 43.581 94.199 80.534 94.728 114.633c0 .032.009.064.009.095 1.54 75.125 57.814 140.143 136.323 148.913V433.09c-51.979 4.254-91.823 27.358-91.823 38.974 0 12.834 48.501 23.217 108.341 23.217 59.839 0 108.345-10.383 108.345-23.217 0-11.616-39.857-34.725-91.841-38.974zM143.823 33.021h207.502c10.361 28.255 16.227 56.47 16.227 78.541 0 5.359-.476 10.61-1.16 15.792-10.324-2.573-21.025-2.913-32.504 1.173-29.977 10.673-49.411 17.509-79.909 5.549-30.325-11.901-49.488-65.96-85.852-61.847-14.447 1.626-26.842 6.378-38.031 12.979 2.596-16.38 7.126-34.18 13.727-52.187z" }, null, -1)
  ])))
}
export default { render: render }